module.exports = __webpack_public_path__ + "img/hr-tree-09-b-trunk.75208d4b.png";